import http from "./http";

// GET all games
export const getAllPointsGames = () => {
  return http.get("points_game/get-all-games");
};

// CREATE game
export const createPointsGame = (data) => {
  return http.post("points_game/create", data);
};

// DELETE game
export const deletePointsGame = (id) => {
  return http.post("points_game/delete", { id });
};


